module.exports = __webpack_public_path__ + "img/t2-c14.b9a7f497.png";